
import "@/styles/pages/recordScreenOnline/index.css"
import "@/styles/pages/recordAudioOnline/index.css"
import ysFixWebmDuration from "./fix-webm-duration.js"
import Recorder from "./record.wav.min.js"
import QRCode from "qrcode"
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // record-screen-online
// record-screen-online.php
/* eslint-disable */

const { injectAudioTools, injectPlayBanner, showAudioDownloadAfterDialog } = require("./recordSreenOnlineDialog.js");

new Vue({
	created($, apower,) {
		let gumStream;
		let gdmStream;
		let recorder;
		let recordingData = [];
		let recorderStream;
		const isMac = /Mac/i.test(window.navigator.userAgent);
		let useMic = true;
		let useAudio = isMac ? false : true;
		let recordedSeconds = 0;
		let recordedCountTime = 0;
		let audioName = null;
		let recordStatus = 'setting';
		let hasMicrophone;
		let fileUploading = false;
		let countTimer = null;
		let isReadyCounting = false;
		let bindFn = null;
		let fixedVideoBlob = null;
		const previewAudio = document.getElementById('preview-audio');
		let client;
		let isClickShare = false;
		let shareUrl = "";//用于分享的url\
		let isClickEdit = false;
		let editUrl = "";
		let videoUniqueId = "";

		const langMap = new Map([["ar", "en"], ["el", "en"], ["cs", "cz"], ["ja", "jp"], ["da", "dk"], ["sv", "se"], ["kr", "en"]]);
		const lang = langMap.get(apower.lang) || apower.lang;
		const langCode = langMap.get(apower.lang) || lang;
		const inBrowser = typeof window !== "undefined";
		const UA = inBrowser && window.navigator.userAgent.toLowerCase();
		const isEdge = UA && UA.indexOf("edge/") > 0;
		const isFirefox = UA && UA.indexOf("firefox") > 0;
		const isSafari = UA && UA.indexOf("chrome") < 0 && UA.indexOf("safari") > 0;
		const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;


		(function checkDevices() {
			// console.log('type support')
			// console.log('audio/mp3', MediaRecorder.isTypeSupported('audio/mp3'))
			navigator.mediaDevices.enumerateDevices().then(devices => {
				hasMicrophone = devices.some(device => device.kind === "audioinput");
				useMic = hasMicrophone;
				if (useMic) {
					initMicDevice();
				}
				triggerMediaChecked();

				const container = document.querySelector(".devices-list-container");
				if (container.childElementCount === 0) {
					devices.filter(value => {
						return value.kind === "audioinput" && value.deviceId.length > 20;
					}).filter(value => {
						return value.label.toLowerCase().includes("Virtual".toLowerCase()) === false;
					}).reduce((prev, cur) => {
						let exist = prev.find(item => item.label === cur.label);
						if (!exist) {
							prev.push(cur);
						}
						return prev;
					}, []).forEach((device, index, array) => {
						if (array.length > 1) {
							document.querySelector(".device-title").classList.add("active");
						}
						buildDeviceListEl(device, container);
					});
				}
			});
		})()

		function inject() {
			injectAudioTools("#audio-tools-container-id");
			const chatVideoBtn = document.querySelector("#chat-video-id");
			const speechToTextBtn = document.querySelector("#speech-to-text");
			chatVideoBtn.onclick = clickChatVideo;
			speechToTextBtn.onclick = clickSpeechToText;

			async function clickChatVideo() {
				if (!apower.user.isLogined()) {
					await apower.user.popupLoginWin(null, true);
				}
				pointUpload({
					event: "click_online_edit",
					function: "chat_video"
				}).then();
				isClickEdit = true;
				editUrl = _getUrl() + "/chat-video";

				if (videoUniqueId) {
					const token = apower.user.apiToken;
					window.open(editUrl + `?uniqid=${videoUniqueId}&api_token=${token}&apptype=chn-online-audio-recorder`, "_blank");
				} else {
					clickUploadBtn();
				}
			}

			async function clickSpeechToText() {
				if (!apower.user.isLogined()) {
					await apower.user.popupLoginWin(null, true);
				}
				pointUpload({
					event: "click_online_edit",
					function: "speech_to_text_online"
				}).then();
				isClickEdit = true;
				editUrl = _getUrl() + "/speech-to-text-online";

				if (videoUniqueId) {
					const token = apower.user.apiToken;
					window.open(editUrl + `?uniqid=${videoUniqueId}&api_token=${token}&apptype=chn-online-audio-recorder`, "_blank");
				} else {
					clickUploadBtn();
				}
			}

			injectPlayBanner("#play-download-banner-id");
		}

		inject();

		/**
		 *
		 * @param device {InputDeviceInfo}
		 * @param container {HTMLElement}
		 */
		function buildDeviceListEl(device, container) {
			if (device.label) {
				const li = document.createElement("li");
				li.classList.add("device-item");
				li.dataset.deviceId = device.deviceId;
				li.textContent = device.label;
				container.appendChild(li);
			}
		}

		// 复写header entry click事件
		$.extend($.getComponent("header-account-entry").prototype, {
			onClick() {
				if (!apower.user.isLogined()) {
					apower.user.popupLoginWin(null, true);
				}
			},
		})

		function convertBase64ToBlob(imageEditorBase64, type) {
			var base64Arr = imageEditorBase64.split(",");
			var imgtype = type;
			var base64String = "";
			if (base64Arr.length > 1) {
				base64String = base64Arr[1];
			}
			// 将base64解码
			var bytes = atob(base64String);
			//var bytes = base64;
			var bytesCode = new ArrayBuffer(bytes.length);
			// 转换为类型化数组
			var byteArray = new Uint8Array(bytesCode);

			// 将base64转换为ascii码
			for (var i = 0; i < bytes.length; i++) {
				byteArray[i] = bytes.charCodeAt(i);
			}

			// 生成Blob对象（文件对象）
			return new Blob([bytesCode], { type: imgtype });
		}
		function _getUrl() {
			const isDev = apower.user.isDev();
			const langMap = new Map([["ar", "en"], ["el", "en"], ["cs", "cz"], ["ja", "jp"], ["da", "dk"], ["sv", "se"], ["kr", "en"]]);
			const lang = langMap.get(apower.lang) || apower.lang;
			const langCode = langMap.get(apower.lang) || lang;
			let recHref = lang === "zh" ? "https://reccloud.cn" : lang === "en" ? "https://reccloud.com" : `https://reccloud.com/${langCode}`;
			if (isDev) {
				recHref =
					lang === "zh"
						? "https://dev-reccloud-cn.aoscdn.com"
						: lang === "en"
							? "https://dev-reccloud-com.aoscdn.com"
							: `https://dev-reccloud-com.aoscdn.com/${langCode}`;
			}

			return recHref;
		}

		function triggerMediaChecked() {
			if (useMic) {
				$("#trigger-microphone").addClass('active');
				$("#chooseMic").addClass('active');
			} else {
				$("#trigger-microphone").removeClass('active');
				$("#chooseMic").removeClass('active');
			}
			if (useAudio) {
				$("#trigger-sound").addClass('active');
				$("#chooseAudio").addClass('active');
			} else {
				$("#trigger-sound").removeClass('active');
				$("#chooseAudio").removeClass('active');
			}
			if (useMic || useAudio) {
				$("#start-record").removeClass("not-allow");
			} else {
				$("#start-record").addClass("not-allow");
			}
		}
		$("#trigger-sound").off("click").on('click', () => {
			useAudio = !useAudio;
			if (useAudio) {
				if (isMac) {
					$("#getAppTip").css('display', 'flex');
					$("#getAppDefaultContent").css('display', 'none');
					$("#noDisplayMedia").css('display', 'none');
					$("#firefoxAudioTip").css('display', 'none');
					$("#macAudioNotSupport").show();
				} else if (isFirefox) {
					$("#getAppTip").css('display', 'flex');
					$("#getAppDefaultContent").css('display', 'none');
					$("#noDisplayMedia").css('display', 'none');
					$("#macAudioNotSupport").css('display', 'none');
					$("#firefoxAudioTip").show();
				}
			}

			triggerMediaChecked();
		})
		$("#trigger-microphone").off("click").on('click', async () => {
			if (hasMicrophone) {
				useMic = !useMic;
				if (useMic) {
					initMicDevice();
				}
			} else {
				useMic = false
				$("#noMicTip").css('display', 'flex');
			}
			triggerMediaChecked();
		})
		$("#device-list").off("click").on("click", function(ev) {
			ev.stopPropagation();
			if (ev.target) {
				const isItem = ev.target.classList.contains("device-item");
				if (isItem) {
					const list = document.querySelector("#device-list");
					list.dataset.deviceId = ev.target.dataset.deviceId;
					const deviceName = document.querySelector("#device-name");
					deviceName.textContent = ev.target.textContent;
					hiddenDeviceList();
					useMic = true;
					triggerMediaChecked();
				}
			}
		});

		function showDeviceList() {
			const container = document.querySelector(".devices-list-container");
			container.style.visibility = "visible";
		}

		function hiddenDeviceList(selector = ".devices-list-container") {
			const container = document.querySelector(selector);
			container.style.visibility = "hidden";
		}

		function toggleDeviceList(selector = ".devices-list-container") {
			const container = document.querySelector(selector);
			const status = getComputedStyle(container).visibility;
			if (status === "hidden") {
				container.style.visibility = "visible";
			} else {
				container.style.visibility = "hidden";
			}
		}

		$(".update-device").off("click").on("click", function(ev) {
			const container = document.querySelector(".devices-list-container");
			if (container.childElementCount > 1) {
				ev.stopPropagation();
				toggleDeviceList();
			}
		});

		$("#device-name").off("click").on("click", function(ev) {
			const container = document.querySelector(".devices-list-container");
			if (container.childElementCount > 1) {
				ev.stopPropagation();
				toggleDeviceList();
			}
		});

		//点击空白区域关闭设备选择列表
		document.body.onclick = function() {
			hiddenDeviceList();
		}

		function initMicDevice() {
			const list = document.querySelector("#device-list");
			if (list && list.children[0] && Boolean(list.dataset.deviceId) === false) {
				list.children[0].click();
			}
		}

		$("#subStartBtn").off("click").on("click", () => {
			if (recordStatus == 'setting') {
				$("#onlineAudioRecorderBox").css('display', 'flex');
				$("#oldAudioIndexBox").hide();
				startRecord();
			}
		})
		$("#start-record").off("click").on('click', startRecord);
		async function startRecord() {
			if (!useMic && !useAudio) return;
			const displayMediaOptions = { video: true, audio: useAudio };
			if (useMic) {
				initUserMedia();
			} else {
				if (useAudio) initDisplayMedia(displayMediaOptions);
			}
		}
		async function initUserMedia() {
			try {
				const container = document.querySelector("#device-list");
				const constraints = useMic ? {
					audio: {
						deviceId: container.dataset.deviceId
					}
				} : false;
				gumStream = await navigator.mediaDevices.getUserMedia(constraints);
				if (useAudio) {
					const displayMediaOptions = { video: true, audio: useAudio };
					initDisplayMedia(displayMediaOptions);
				} else {
					readyCountDown(gumStream);
				}
			} catch (e) {
				console.log(e)
				showNotAllowedTip();
				useMic = false;
				// useAudio = false;
				$("#trigger-microphone").removeClass('active');
				// $("#trigger-sound").removeClass('active');
				triggerMediaChecked();
			}
		}
		async function initDisplayMedia(options) {
			try {
				if (isEdge || isChrome) {
					// show step tips
					const showedAudioGuide = localStorage.getItem('showedAudioGuide');
					if (!showedAudioGuide) {
						$(".screen-recorder-container .step-guides").fadeIn(400);
						localStorage.setItem('showedAudioGuide', 'true');
					}
				}
				gdmStream = await navigator.mediaDevices.getDisplayMedia(options);
				readyCountDown(gdmStream);
				// hide guide after share or cancel or some error
				hideStepGuides();
				gdmStream.getVideoTracks()[0].addEventListener('ended', () => {
					if (isReadyCounting) {
						$("#countdownBox").css('display', 'none');
						clearInterval(countTimer);
						backToSetting();
						const countNum = document.getElementById('countdownNum');
						countNum.innerText = 3;
						isReadyCounting = false;
						recordedSeconds = 0;
					} else {
						stopMediaRecord();
					}
				})
			} catch (e) {
				// hide guide after share or cancel or some error
				hideStepGuides();
				console.log(e)
				console.log(e.name)
				console.log(e.message)
				if (e.name == 'NotFoundError' || e.message == 'The object can not be found here.' || e.name == 'TypeError') {
					$("#getAppTip").css('display', 'flex');
					$("#getAppDefaultContent").css('display', 'none');
					$("#noDisplayMedia").show();
					$("#macAudioNotSupport").css('display', 'none');
					$("#firefoxAudioTip").css('display', 'none');
				} else {
					$(".light-top-tip").addClass('active');
					setTimeout(() => {
						$(".light-top-tip").removeClass('active');
					}, 2000)
				}
				stopMediaRecord();
				console.log('授权失败！')
			}
		}
		function readyCountDown(stream) {
			showLongTimeTip();
			isReadyCounting = true;
			audioName = null;
			recordStatus = 'recording';
			recordingData = [];
			triggerMediaChecked();
			changeDisplayBlock();
			$("#countdownBox").css('display', 'flex');
			const countNum = document.getElementById('countdownNum');
			let start = 3;
			countTimer = setInterval(() => {
				if (start > 1) {
					start -= 1;
					countNum.innerText = start;
				} else if (start == 1) {
					start -= 1;
					$("#countdownBox").css('display', 'none');
				} else {
					clearInterval(countTimer);
					startMediaRecord(stream);
					countNum.innerText = 3;
					isReadyCounting = false;
				}
			}, 1000)
		}

		async function startMediaRecord(gdmStream) {
			recorderStream = gumStream ? mixStream(gumStream, gdmStream) : gdmStream;
			recorder = new MediaRecorder(recorderStream, { mimeType: gumStream ? 'audio/webm;codecs=opus' : ''});

			recorder.start();
			recorder.ondataavailable = function (e) {
				if (e.data && e.data.size > 0) {
					recordingData.push(e.data);
				}
			};
			recorder.onstart = () => {
				$("#start-record").attr("disabled", true);
				$("#stop-record").removeAttr("disabled");
				$("#pause-record").removeAttr("disabled");
				startCountdown();
			};
			recorder.onstop = () => {
				if (document.pictureInPictureElement) document.exitPictureInPicture();
				stopCountdown();
				if (recordStatus == 'recording' || recordStatus == 'pause') {
					recordStatus = 'preview';
					$("#onlineAudioRecorderBox").addClass('preview-main-box');
					$("#recordOnlineTitle").hide();
					audioName = getAudioFilename() + '.mp3';
					const blob = new Blob(recordingData, { type: 'audio/mp3' });
					ysFixWebmDuration(blob, recordedSeconds).then(fixedBlob => {
						fixedVideoBlob = fixedBlob;
						initPreviewAudio();
					})
				}
				$("#pause-record").removeClass("record-resume");
				$("#pause-record").addClass("record-pause");
				$(".pause-resume-word.resume").hide();
				$(".pause-resume-word.pause").show();
				$("#goBackDialog").css('display', 'none');
				recorder = null;
				changeDisplayBlock();
			};
			recorder.onpause = () => {
				stopCountdown();
			}
			recorder.onresume = () => {
				startCountdown();
			}
			recorderStream.addEventListener('inactive', () => {
				// console.log('Capture stream inactive');
			});
		}

		function stopMediaRecord() {
			$("#start-record").removeAttr("disabled");
			$("#stop-record").attr("disabled", true);
			$("#pause-record").attr("disabled", true);
			if (recorderStream) recorderStream.getTracks().forEach(track => track.stop());
			if (gumStream) gumStream.getTracks().forEach(track => track.stop());
			if (gdmStream) gdmStream.getTracks().forEach(track => track.stop());
		}

		$("#stop-record").off("click").on('click', stopMediaRecord);

		function mixStream(gumStream, gdmStream) {
			let tracks = [];
			// console.log("gumStream tracks", gumStream.getAudioTracks(), gumStream.getVideoTracks());
			// console.log("gdmStream tracks", gdmStream.getAudioTracks(), gdmStream.getVideoTracks());
			if (useMic && !useAudio) {
				if (gumStream.getAudioTracks().length > 0) tracks = tracks.concat(gumStream.getAudioTracks());
			} else if (useAudio && !useMic) {
				if (gdmStream.getAudioTracks().length > 0) tracks = tracks.concat(gdmStream.getAudioTracks());
			} else if (useAudio && useMic) {
				const ctx = new AudioContext();
				const dest = ctx.createMediaStreamDestination();
				if (gumStream.getAudioTracks().length > 0) ctx.createMediaStreamSource(gumStream).connect(dest);
				if (gdmStream.getAudioTracks().length > 0) ctx.createMediaStreamSource(gdmStream).connect(dest);
				tracks = tracks.concat(dest.stream.getTracks());
			}
			// tracks = tracks.concat(gumStream.getVideoTracks()).concat(gdmStream.getVideoTracks());
			// console.log("mixed tracks", tracks)
			return new MediaStream(tracks)
		}
		function initPreviewAudio() {
			let src = window.URL.createObjectURL(fixedVideoBlob);
			previewAudio.src = src;
			calcAudioDuration();
		}

		function formatMilliseconds(ms) {
			// 1- Convert to seconds:
			var seconds = ms / 1000;

			// 2- Extract hours:
			var hours = parseInt(seconds / 3600); // 3600 seconds in 1 hour
			seconds = parseInt(seconds % 3600); // extract the remaining seconds after extracting hours

			// 3- Extract minutes:
			var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute

			// 4- Keep only seconds not extracted to minutes:
			seconds = Math.ceil(seconds % 60);

			// 5 - Format so it shows a leading zero if needed
			let hoursStr = ("00" + hours).slice(-2);
			let minutesStr = ("00" + minutes).slice(-2);
			let secondsStr = ("00" + seconds).slice(-2);

			return hoursStr + ":" + minutesStr + ":" + secondsStr
		}
		function audioDisplayDuration(ms) {
			var seconds = ms / 1000 || 0;
			var hours = parseInt(seconds / 3600);
			seconds = parseInt(seconds % 3600);
			var minutes = parseInt(seconds / 60);
			seconds = Math.ceil(seconds % 60);
			let hoursStr = hours ? ("00" + hours).slice(-2) + ":" : recordedSeconds >= 3600 * 1000 ? "00:" : "";
			let minutesStr = ("00" + minutes).slice(-2);
			let secondsStr = ("00" + seconds).slice(-2);
			return hoursStr + minutesStr + ":" + secondsStr
		}
		let recordingCountdown;
		const spanRecordingDuration = document.getElementById('recordedTime');
		function startCountdown() {
			$('.recording-animation .dotting').addClass('active');
			const startedAt = (new Date()).getTime();
			let fnCountdown = function () {
				let current = (new Date()).getTime();
				recordedCountTime = (current - startedAt);
				let diff = formatMilliseconds(recordedSeconds + recordedCountTime);
				spanRecordingDuration.innerText = diff;
			};
			recordingCountdown = self.setInterval(fnCountdown, 1000);
			fnCountdown();
		}
		function stopCountdown() {
			$('.recording-animation .dotting').removeClass('active');
			// 暂停时记录已经录制的时间加上新录制的时长
			recordedSeconds += recordedCountTime;
			clearInterval(recordingCountdown);
			recordedCountTime = 0;
		}
		function getAudioFilename() {
			let padTo2Digits = function (num) {
				return num.toString().padStart(2, '0');
			}

			let date = new Date();
			let time = [
				date.getFullYear(),
				padTo2Digits(date.getMonth() + 1),
				padTo2Digits(date.getDate()),
				padTo2Digits(date.getHours()),
				padTo2Digits(date.getMinutes()),
				padTo2Digits(date.getSeconds()),
			].join('-');
			return "recording-" + time
		}

		function changeDisplayBlock() {
			switch (recordStatus) {
				case 'setting':
					$("#recordSetting").css('display', 'block');
					$('#recordCounting').css('display', 'none');
					$('#recordPreview').css('display', 'none');
					break;
				case 'recording':
					$("#recordSetting").css('display', 'none');
					$('#recordCounting').css('display', 'block');
					$('#recordPreview').css('display', 'none');
					break;
				case 'pause':
					$("#recordSetting").css('display', 'none');
					$('#recordCounting').css('display', 'block');
					$('#recordPreview').css('display', 'none');
					break;
				case 'preview':
					$("#recordSetting").css('display', 'none');
					$('#recordCounting').css('display', 'none');
					$('#recordPreview').css('display', 'block');
					break;
				default:
					$("#recordSetting").css('display', 'block');
					$('#recordCounting').css('display', 'none');
					$('#recordPreview').css('display', 'none');
					break;
			}
		}
		function backToSetting() {
			videoUniqueId = "";
			recordStatus = 'setting';
			$("#onlineAudioRecorderBox").removeClass('preview-main-box');
			$("#recordOnlineTitle").show();
			const spanRecordingDuration = document.getElementById('recordedTime');
			spanRecordingDuration.innerText = '00:00:00';
			if (!previewAudio.paused) {
				pauseAudio();
			}
			previewAudio.src = null;
			recordedSeconds = 0;
			recordedCountTime = 0;
			audioPlayedTime = 0;
			audioCountTime = 0;
			triggerMediaChecked();
			changeDisplayBlock();
			stopMediaRecord();
			$("#progressBar").css('width', 0);
			$("#dragProgressBtn").css('left', 0);
			writePlayedTime(0);
		}
		let fileDownloading = false;
		$("#downloadRecordVideo").off("click").on('click', () => {
			if(fileDownloading) return;
			fileDownloading = true;
			// 30分钟以内的音频使用JS重新编码，30分钟以上的文件JS重编码可能会导致浏览器崩溃，直接下载webm文件
			if(recordedSeconds < 1800000) {
				// 若时长大于十分钟，则显示转码弹窗，防止转码太久无响应
				if(recordedSeconds > 600000) {
					// show converting dialog
					$("#convertDialog").css('display', 'flex');
				}
				let fileReader = new FileReader();
				let fileData, webmChunks = [];
				fileReader.onload = async function() {
					fileData = this.result;
					webmChunks.push(new Uint8Array(fileData));
					var blob = new Blob(webmChunks, { type: "audio/webm" });
					const wavBlob = await convertWebmAudio(blob);
					const url = URL.createObjectURL(wavBlob);
					const a = document.createElement("a");
					a.style.display = "none";
					a.href = url;
					a.download = audioName;
					document.body.appendChild(a);
					a.click();
					setTimeout(() => {
						document.body.removeChild(a);
						window.URL.revokeObjectURL(url);
						fileDownloading = false;
						$("#convertDialog").css("display", "none");
					}, 100);
					checkShowDownloadDialog()
				}
				const blob = new Blob(recordingData, { type: 'audio/webm' });
				fileReader.readAsArrayBuffer(blob);
			} else {
				directDownload();
				checkShowDownloadDialog()
			}
		});

		$("#download-video-id,.more-download-btn").off("click").on("click", () => {
			window.localStorage.setItem("download-client-key", "true");
		});

		function checkShowDownloadDialog() {
			//已经点击过下载, 不再弹窗 未点击过 检查是否在一天内, 不在一天内弹窗
			const clicked = window.localStorage.getItem("download-client-key");
			if (clicked) {
				return;
			}
			const lastTime = window.localStorage.getItem("download-client-time");
			if (lastTime) {
				const now = new Date().getTime();
				if (now - lastTime < 24 * 60 * 60 * 1000) {
					return;
				}
			}
			showAudioDownloadAfterDialog();
			localStorage.setItem("download-client-time", new Date().getTime().toString());
		}

		function directDownload() {
			const url = window.URL.createObjectURL(fixedVideoBlob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = url;
			a.download = audioName.replace(".mp3", '.aac');
			document.body.appendChild(a);
			a.click();
			setTimeout(() => {
				document.body.removeChild(a);
				window.URL.revokeObjectURL(url);
				fileDownloading = false;
			}, 100);
		}


		// audio player
		function calcAudioDuration() {
			const audioDuration = audioDisplayDuration(recordedSeconds);
			const audioTotal = document.getElementById("audio-total");
			audioTotal.innerText = audioDuration;
			const audioPlayedDuration = document.getElementById('audio-played');
			audioPlayedDuration.innerText = recordedSeconds >= 3600 * 1000 ? "00:00:00" : "00:00";
		}
		$(".preview-record-audio-box").hover(function () {
			$("#audioPlayControlBar").css('opacity', 1);
		}, function () {
			if (!previewAudio.paused) $("#audioPlayControlBar").css('opacity', 0);
		})
		if (previewAudio) {
			previewAudio.addEventListener('ended', () => {
				$("#playPauseAudio").addClass("play");
				$("#playPauseAudio").removeClass("pause");
				$(".line-box").removeClass("active");
				audioPlayedTime = 0;
				audioCountTime = 0;
				stopAudioPlayCountdown();
			});
			$("#playPauseAudio").off("click").on("click", () => {
				if (previewAudio.paused) {
					playAudio();
				} else {
					pauseAudio();
				}
			});
			// 拖动按钮取消冒泡
			const dragBtn = document.getElementById("dragProgressBtn");
			dragBtn.addEventListener("click", (e) => {
				e.stopPropagation();
			})
			$("#dragProgressBtn").off("mousedown").on("mousedown", dragProgressStart);
			$("#dragProgressBtn").off("mouseup").on("mouseup", dragProgressEnd);
			const volumeBtn = document.getElementById("changeVolumeBtn");
			volumeBtn.addEventListener("click", (e) => {
				e.stopPropagation();
			})
			$("#changeVolumeBtn").off("mousedown").on("mousedown", dragVolumeStart);
		}
		let audioPlayingBeforeDrag = false;
		function playAudio() {
			$("#playPauseAudio").addClass("pause");
			$("#playPauseAudio").removeClass("play");
			$(".line-box").addClass("active");
			previewAudio.play();
			startAudioPlayCountdown();
			audioPlayingBeforeDrag = false;
		}
		function pauseAudio() {
			$("#playPauseAudio").addClass("play");
			$("#playPauseAudio").removeClass("pause");
			$(".line-box").removeClass("active");
			previewAudio.pause();
			stopAudioPlayCountdown();
		}

		let audioCountdown;
		let audioPlayedTime = 0;
		let audioCountTime = 0;
		function startAudioPlayCountdown() {
			const startedAt = (new Date()).getTime();
			let fnCountdown = function () {
				let current = (new Date()).getTime();
				audioCountTime = (current - startedAt);
				let sec = audioPlayedTime + audioCountTime;
				sec = sec > recordedSeconds + 400 ? recordedSeconds : sec;
				writePlayedTime(sec);
				calcAudioProgressBar(sec);
			};
			audioCountdown = self.setInterval(fnCountdown, 1000);
			fnCountdown();
		}
		function stopAudioPlayCountdown() {
			// 暂停时记录已经录制的时间加上新录制的时长
			audioPlayedTime += audioCountTime;
			clearInterval(audioCountdown);
		}
		function calcAudioProgressBar(sec) {
			let precent = ((sec / recordedSeconds) * 100).toFixed(2);
			$("#progressBar").css('width', precent + '%');
			$("#dragProgressBtn").css('left', precent + '%');
		}
		function writePlayedTime(sec) {
			let time = audioDisplayDuration(sec);
			const audioPlayedDuration = document.getElementById('audio-played');
			audioPlayedDuration.innerText = time;
		}
		$("#audioTimeline").off("click").on("click", (e) => {
			let clickX = e.offsetX;
			let total = $("#audioTimeline")[0].clientWidth;
			let sec = clickX / total * recordedSeconds;
			let newTime = Math.round(sec / 1000);
			previewAudio.currentTime = newTime;
			audioPlayedTime = sec;
			audioCountTime = 0;
			calcAudioProgressBar(sec);
			if (!previewAudio.paused) {
				clearInterval(audioCountdown);
				// previewAudio.play();
				startAudioPlayCountdown();
			} else {
				writePlayedTime(sec);
			}
		})
		function dragProgressStart(e) {
			const startX = e.x;
			const barWidth = $("#audioTimeline")[0].clientWidth;
			const oldLeft = (audioPlayedTime / recordedSeconds) * barWidth || 0;
			clearInterval(audioCountdown);
			if (!previewAudio.paused) {
				audioPlayingBeforeDrag = true;
				previewAudio.pause();
			}
			function moveEvent(e) {
				let move = e.x - startX;
				let left = Math.max(0, Math.min(oldLeft + move, barWidth));
				let sec = left / barWidth * recordedSeconds;
				let newTime = Math.round(sec / 1000);
				audioPlayedTime = sec;
				previewAudio.currentTime = newTime;
				calcAudioProgressBar(sec);
				writePlayedTime(sec);
			}
			document.onmousemove = function (e) {
				moveEvent(e);
			}
			document.onmouseup = function () {
				document.onmousemove = null;
			}
		}
		function dragProgressEnd() {
			if (audioPlayingBeforeDrag) {
				clearInterval(audioCountdown);
				previewAudio.play();
				startAudioPlayCountdown();
			}
			audioPlayingBeforeDrag = false;
		}
		$("#volumeBar").off("click").on("click", (e) => {
			e.stopPropagation();
			let clickY = e.offsetY;
			let total = $("#volumeBar")[0].clientHeight;
			if (e.target == $("#audioVolume")[0]) {
				clickY = clickY + e.target.offsetTop;
			}
			let rate = ((1 - (clickY / total)) * 100).toFixed(2);
			$("#audioVolume").css("height", rate + '%');
			$("#changeVolumeBtn").css("bottom", rate + '%');
		})
		function dragVolumeStart(e) {
			const startY = e.y;
			const barHeight = $("#volumeBar")[0].clientHeight;
			const oldHeight = previewAudio.volume * barHeight;
			function moveEvent(e) {
				let move = e.y - startY;
				let top = Math.max(0, Math.min(oldHeight - move, barHeight));
				let vol = (top / barHeight).toFixed(1);
				previewAudio.volume = vol;
				if (top == 0) {
					$(".volume-icon").addClass("mute-icon");
				} else {
					$(".volume-icon").removeClass("mute-icon");
				}
				$("#audioVolume").css("height", vol * 100 + '%');
				$("#changeVolumeBtn").css("bottom", vol * 100 + '%');
			}
			document.addEventListener("mousemove", moveEvent);
			document.addEventListener("mouseup", mouseUp);
			function mouseUp() {
				document.removeEventListener('mousemove', moveEvent);
				document.removeEventListener('mouseup', mouseUp);
			}
		}
		$(".volume-box").hide();
		$(".volume-icon").hover(function () {
			$(this).addClass('active');
			$(".volume-box").fadeIn(200);
		}, function () {
			$(this).removeClass('active');
			$(".volume-box").fadeOut(200);
		})
		$("#shareRecordVideo").off("click").on("click", handleShare);
		let tipTimer;
		let tipShowTime;
		function showLongTimeTip() {
			if(tipTimer) clearTimeout(tipTimer);
			// show long time tips
			const showedLongAudioRecordTip = localStorage.getItem('showedLongAudioRecordTip');
			if (!showedLongAudioRecordTip) {
				tipShowTime = new Date().getTime();
				$(".long-time-tip").addClass('active');
				addTipTimer();
			}
		}
		$(".long-time-tip").hover(function () {
			clearTimeout(tipTimer);
		}, function () {
			const timeNow = new Date().getTime();
			if (timeNow - tipShowTime >= 10000) {
				$(".long-time-tip").removeClass('active');
			} else {
				let leftTime = 10000 - (timeNow - tipShowTime);
				addTipTimer(leftTime);
			}
		})
		function addTipTimer(duration) {
			let time = duration || 10000;
			tipTimer = setTimeout(() => {
				$(".long-time-tip").removeClass('active');
				clearTimeout(tipTimer);
			}, time);
		}
		$("#closeLongTimeTip").off("click").on("click", hideLongTimeTip)
		function hideLongTimeTip() {
			$(".long-time-tip").removeClass('active');
			localStorage.setItem('showedLongAudioRecordTip', 'true');
		}
		function hideStepGuides() {
			$(".screen-recorder-container .step-guides").fadeOut(50);
		}

		let reccloudURL = apower.lang == "zh" ? "https://aw.aoscdn.com/app/reccloud/v2" : "https://gw.aoscdn.com/app/reccloud/v2";
		if (apower.user.isDev()) {
			reccloudURL = apower.lang === "zh" ? "https://devaw.aoscdn.com/app/reccloud/v2" : "https://devgw.aoscdn.com/app/reccloud/v2";
		}

		async function pointUpload(params = {}, isRec = false) {
			const id = isRec ? "293" : "035";
			const language = apower.lang;
			const browser = window.navigator.userAgent;
			const host = window.location.host;
			let url = `https://wx-user-behavior.cn-hongkong.log.aliyuncs.com/logstores/${id}/track?APIVersion=0.6.0&language=${language}&browser=${browser}&host=${host}`;
			const searchParams = new window.URLSearchParams();
			const mergeParams = {
				online_web: "1",
				...params
			};
			for (const paramsKey in mergeParams) {
				searchParams.append(paramsKey, mergeParams[paramsKey]);
			}
			if (searchParams.toString()) {
				url += `&${searchParams.toString()}`;
			}

			await fetch(url);
		}

		function handleShare() {
			isClickEdit = false;
			pointUpload({
				event: "click_share_file"
			}).then();
			if (videoUniqueId) {
				openShareDialog(shareUrl);
			} else {
				isClickShare = true;
				clickUploadBtn();
			}
		}
		function openShareDialog(url) {
			const shareDialog = document.querySelector("#shareDialog");
			if (shareDialog) {
				if (lang === "zh") {
					const imgContainer = shareDialog.querySelector(".app-tip-img-container");
					QRCode.toDataURL(url)
						.then(resultUrl => {
							imgContainer.innerHTML = `<img id="app-qrcode-id" src="${resultUrl}" width="100%" height="100%" style="display: block;"/>`;
						})
						.catch(err => {
							console.error(err);
						});
					const copyImgBtn = shareDialog.querySelector("#copy-img-code");
					copyImgBtn.onclick = function() {
						const img = document.querySelector("#app-qrcode-id");
						const file = convertBase64ToBlob(img.src, "image/png");
						const clipboardItemInput = new ClipboardItem({
							"image/png": file
						});
						navigator.clipboard.write([clipboardItemInput]).then(copySuccessToast);
					};
				}

				const closeBtn = shareDialog.querySelector("#closeShareBtn");
				closeBtn.onclick = function() {
					shareDialog.style.display = "none";
				};

				const copyUrlBtn = shareDialog.querySelector("#copy-url");
				copyUrlBtn.onclick = function() {
					navigator.clipboard.writeText(url).then(copySuccessToast);
				};

				const input = shareDialog.querySelector(".url-input");
				input.value = url;
				shareDialog.style.display = "flex";

				function copySuccessToast() {
					$(".copy-success-tip").addClass('active');
					let tipTimer = setTimeout(() => {
						$(".copy-success-tip").removeClass('active');
						clearTimeout(tipTimer);
					}, 2000)
				}
			}
		}
		function uploadProgress(progress) {
			let pro = Math.ceil(progress * 100);
			const base = 372;
			let pronum = base - (base / 100) * pro;
			$("#progressCircle").css('stroke-dashoffset', pronum);
			const progressNum = document.getElementById('progressNum');
			progressNum.innerText = pro;
			if (progress == 1) {
				bindFn = null;
			}
		}

		async function editDefaultVideo(videoInfo) {
			const posts = {
				title: audioName,
				app_lang: langCode,
				permission: 2,
				app_id: 'Chrome Online Recorder',
				app_version: 'V1.0',
			}
			videoUniqueId = videoInfo.uniqid;
			const apiToken = apower.user.apiToken;
			const { ok, data } = await $.req.put(`${reccloudURL}/videos/${videoInfo.uniqid}`, posts, { headers: { Authorization: "Bearer " + apiToken } });
			if (ok) {
				const token = apower.user.apiToken;
				const href = `${data.data.video_open_url}?api_token=${token}`;
				shareUrl = data.data.video_open_url;
				$("#uploadingDialog").css("display", "none");
				const progressNum = document.getElementById("progressNum");
				$("#progressCircle").css("stroke-dashoffset", 372);
				progressNum.innerText = 0;
				if (isClickShare) {
					openShareDialog(shareUrl);
				} else {
					if (isClickEdit) {
						const token = apower.user.apiToken;
						window.open(editUrl+`?uniqid=${videoUniqueId}&api_token=${token}&apptype=chn-online-screen-recorder`, "_blank");
					} else {
						window.open(href, "_blank");
					}
				}

			}
			isClickShare = false;
			fileUploading = false;
		}

		function handleWebmToWav(originBlob) {
			return new Promise((resolve, reject) => {
				if (recordedSeconds < 1800000) {
					// 若时长大于十分钟，则显示转码弹窗，防止转码太久无响应
					if (recordedSeconds > 600000) {
						// show converting dialog
						$("#convertDialog").css("display", "flex");
					}
					let fileReader = new FileReader();
					let fileData, webmChunks = [];
					fileReader.onload = async function() {
						fileData = this.result;
						webmChunks.push(new Uint8Array(fileData));
						var blob = new Blob(webmChunks, { type: "audio/webm" });
						const wavBlob = await convertWebmAudio(blob);
						resolve(wavBlob);
					};
					const blob = new Blob(recordingData, { type: "audio/webm" });
					fileReader.readAsArrayBuffer(blob);
				} else {
					resolve(originBlob);
				}
			});
		}

		async function uploadFileToOss(authentications) {
			$("#uploadingDialog").css('display', 'flex');
			if(recordingData.length == 0) return;
			const data = fixedVideoBlob;
			//获取转换后的blob
			const wavBlob = await handleWebmToWav(data);

			const file = new File([wavBlob], audioName, { type: "video/mp4" });
			let key = authentications.objects[audioName];
			let url = authentications["callback"]["url"];
			let callbackBody = authentications["callback"]["body"];
			let name = encodeURI(audioName);
			let callback = {
				url: url,
				body: callbackBody.replace("${filename}", name) + '&x:object=' + key + '&x:endpoint=' + authentications.endpoint + '&x:bucket=' + authentications.bucket + '&x:user_id=' + apower.user.info.user_id,
				contentType: authentications["callback"]["type"]
			};
			const option = {
				cancelFlag: true,
				callback: callback,
				progress: uploadProgress,
				partSize: 500 * 1024,
			}
			pointUpload({
				event: "upload_start"
			}).then();

			client.multipartUpload(key, file, option).then(function (res) {
				if (res.data.status == 200) {
					const videoInfo = res.data.data;
					editDefaultVideo(videoInfo);
					const info = {
						event: "upload_success",
						file_size: (parseInt(videoInfo.size) / 1024 / 1024).toFixed(2),
						file_time: parseInt(videoInfo.duration) / 1000,
						source_from: "ap_online_recorder"
					}
					pointUpload(info)
					pointUpload(info, true);
				} else {
					isClickShare = false;
					fileUploading = false;
					$("#uploadingDialog").css('display', 'none');
					$("#uploadFailDialog").css('display', 'flex');
				}
			}, function(reason) {
				const info = {
					event: "upload_failed",
					reason: reason.toString()
				}
				pointUpload(info);
				pointUpload(info, true);
			})
		}
		async function authorizationFile() {
			const posts = {
				filenames: [audioName]
			}
			let { ok, data } = await $.req.post(`${reccloudURL}/authorizations/oss`, posts);
			let authentications;
			if (ok) {
				authentications = data.data;
				if (!window.OSS) {
					await $.loadScript(`${window.CDNDOMAIN}/lib/aliyun-oss-sdk.min.js`);
				}
				client = new window.OSS({
					region: authentications.region,
					accessKeyId: authentications.credential.access_key_id,
					accessKeySecret: authentications.credential.access_key_secret,
					stsToken: authentications.credential.security_token,
					bucket: authentications.bucket,
					secure: true,
					endpoint: authentications.endpoint,
				});
			}
			uploadFileToOss(authentications);
		}

		async function getUserInfo() {
			fileUploading = true;
			const userId = apower.user.info.user_id;
			const apiToken = apower.user.apiToken;
			let { ok, data } = await $.req.get(`${reccloudURL}/users/${userId}`, {
				headers: {
					Authorization: "Bearer " + apiToken
				}
			});
			if (ok) {
				const isZh = apower.lang === "zh";
				const isVip = data.data.user_info.type > 0;
				const isOpenVipActive = localStorage.getItem("review-vip-key");

				if (data.data.quota.storage.limit > data.data.quota.storage.used && data.data.quota.quantity.limit > data.data.quota.quantity.used) {
					authorizationFile();
				} else {
					if (data.data.quota.quantity.limit <= data.data.quota.quantity.used) {
						const numBox = document.getElementById("video-limit-num");
						numBox.innerText = data.data.quota.quantity.limit;
						$("#videoNumLimitTip").css("display", "flex");
						pointUpload({
							event: "cloud_limit_pop_up",
							reason: "quantity"
						}).then();
					} else if (data.data.quota.storage.limit <= data.data.quota.storage.used) {
						$("#storageLimitTip").css("display", "flex");
						pointUpload({
							event: "cloud_limit_pop_up",
							reason: "storage"
						}).then();

					}
					// isClickShare = false;
					fileUploading = false;
				}
			}
		}


		function clickUploadBtn(event) {
			if (!fileUploading) {
				const progressNum = document.getElementById("progressNum");
				$("#progressCircle").css("stroke-dashoffset", 372);
				progressNum.innerText = 0;
				$("#uploadFailDialog").css("display", "none");
				if (!apower.user.isLogined()) {
					// 避免重复调用登录弹窗但未登录回调时间被绑定多次重复执行，判断是否已绑定过，绑定过参数传null，在登录后回调执行完成后释放bindFn
					const fn = bindFn ? null : getUserInfo;
					if (!bindFn) bindFn = getUserInfo;
					apower.user.popupLoginWin(fn, true);
				} else {
					getUserInfo();
				}
			}
		}

		$(".to-clean-storage").off("click").on("click", () => {
			toUserPage();
		})
		$(".get-more-storage").off("click").on("click", () => {
			toVipPage();
		})
		function toUserPage() {
			const token = apower.user.apiToken;
			const href = `${_getUrl()}/user/?api_token=${token}`;
			$("#storageLimitTip").css('display', 'none');
			$("#videoNumLimitTip").css('display', 'none');
			window.open(href, '_blank');
		}
		function toVipPage() {
			const token = apower.user.apiToken;
			const href = `${_getUrl()}/vip/?api_token=${token}`;
			$("#storageLimitTip").css('display', 'none');
			$("#videoNumLimitTip").css('display', 'none');
			window.open(href, '_blank');
		}
		$("#cancelUpload").off("click").on("click", () => {
			client.cancel();
			$("#uploadingDialog").css('display', 'none');
			closeUploadFailDialog();
		});
		$("#closeUploadFailBtn").off("click").on("click", closeUploadFailDialog);
		$("#uploadAgainBtn").off("click").on("click", clickUploadBtn);
		function closeUploadFailDialog() {
			$("#uploadFailDialog").css('display', 'none');
			fileUploading = false;
		}

		$("#closeVideoNumLimitTip").off("click").on("click", () => {
			$("#videoNumLimitTip").css('display', 'none');
		})
		$("#uploadRecordVideo").off("click").on("click", clickUploadBtn);
		$("#closeGetAppDialogIcon").off("click").on('click', () => {
			if (isMac || isFirefox) {
				useAudio = false;
				triggerMediaChecked();
			}
			$("#getAppTip").css('display', 'none');
		})
		$("#closeConvertDialog").off("click").on('click', () => {
			fileDownloading = false;
			$("#convertDialog").css("display", "none");
		})
		$("#hideNotAllowedTip").off("click").on("click", () => {
			$("#notAllowedTip").css("display", "none");
		})
		$("#goBackDialog").css('display', 'none');
		$(".pause-resume-word.resume").hide();
		$("#goBackTitle").off("click").on("click", () => {
			$("#goBackDialog").show();
			$("#goBackDialog").css('display', 'flex');
		});
		$("#recordNewTitle").off("click").on("click", backToSetting);
		$("#cancelBack").off("click").on("click", () => {
			$("#goBackDialog").css('display', 'none');
		})
		$("#confirmBack").off("click").on("click", () => {
			$("#goBackDialog").css('display', 'none');
			$("#start-record").removeAttr("disabled");
			$("#stop-record").attr("disabled", true);
			$("#pause-record").attr("disabled", true);
			stopCountdown();
			backToSetting();
		})
		$("#closeMicTip").off("click").on("click", () => {
			$("#noMicTip").css('display', 'none');
		})
		$("#closeOnlineRecorder").off("click").on("click", () => {
			$("#onlineAudioRecorderBox").css('display', 'none');
			$("#oldAudioIndexBox").show();
			backToSetting();
			gumStream = null;
			gdmStream = null;
			recorder = null;
			recorderStream = null;
			recordingData = [];
		})
		function showNotAllowedTip() {
			$("#notAllowedTip").css("display", "flex");
		}
		$("#hideNotAllowedTip").off("click").on("click", () => {
			$("#notAllowedTip").css("display", "none");
		})
		$("#pause-record").off("click").on("click", () => {
			if (recordStatus == "recording") {
				$("#pause-record").addClass("record-resume");
				$("#pause-record").removeClass("record-pause");
				$(".pause-resume-word.pause").hide();
				$(".pause-resume-word.resume").show();
				recordStatus = 'pause';
				recorder.pause();
			} else if (recordStatus == "pause") {
				$("#pause-record").removeClass("record-resume");
				$("#pause-record").addClass("record-pause");
				recordStatus = 'recording';
				recorder.resume();
				$(".pause-resume-word.resume").hide();
				$(".pause-resume-word.pause").show();
			}
		})



		function convertWebmAudio(webmBlob) {
			return new Promise((resolve, reject) => {
				Recorder.WebM_Extract_Audio(webmBlob, function(data) {
					let fileReader = new FileReader();
					fileReader.onload = function() {
						let arr = this.result;

						let end = function(pcm, sampleRate) {
							let mockRec = new Recorder({ type: "wav", sampleRate: 16000, bitRate: 16 });
							mockRec.mock(pcm, sampleRate);
							mockRec.stop(function(blob, duration) {
								resolve(blob);
								// console.log(blob)
							});
						};
						if (data.playType == "pcm") {
							end(new Int16Array(arr), data.playSampleRate);
						} else {
							decodeAudio("", arr, function(obj) {
								end(obj.data, obj.sampleRate);
							});
						}
						;
					}

					fileReader.readAsArrayBuffer(data.playBlob);
				}, function(msg) {
				});
			})
		};
		function decodeAudio(fileName, arrayBuffer, True, False) {
			True = True || null;
			False = False || null;
			if (!Recorder.Support()) {//强制激活Recorder.Ctx 不支持大概率也不支持解码
				return;
			};
			var type = (/[^.]+$/.exec(fileName) || [])[0] || "";
			var srcBlob = new Blob([arrayBuffer], { type: type && ("audio/" + type) || "" });

			var ctx = Recorder.Ctx;
			ctx.decodeAudioData(arrayBuffer, function (raw) {
				var src = raw.getChannelData(0);
				var sampleRate = raw.sampleRate;
				var pcm = new Int16Array(src.length);
				for (var i = 0; i < src.length; i++) {//floatTo16BitPCM
					var s = Math.max(-1, Math.min(1, src[i]));
					s = s < 0 ? s * 0x8000 : s * 0x7FFF;
					pcm[i] = s;
				};

				True({
					sampleRate: sampleRate
					, duration: Math.round(src.length / sampleRate * 1000)
					, srcBlob: srcBlob
					, type: type
					, data: pcm
				});
			}, function (e) {
				console.error("audio解码失败", e);
			});
		}

		//=====WebM格式解析并提取音频 核心函数==========
		Recorder.WebM_Extract_Audio = function (webmBlob, True, False) {
			True = True || function () { };
			False = False || function () { };

			var HeaderEID = [0x1A, 0x45, 0xDF, 0xA3];
			var SegmentEID = [0x18, 0x53, 0x80, 0x67];
			var ClusterEID = [0x1F, 0x43, 0xB6, 0x75];

			var reader = new FileReader();
			reader.onloadend = function () {
				try {
					var fileBytes = new Uint8Array(reader.result);
					var multiHeader = 0, tracks = {}, audioTrackIdx = 0, audioTrack0 = {};
					var duration = [0], duration2 = [0];
					var rawData = [], playData = [], isPcm = 0;
					var position = [0];

					//循环读取 Header+Segment
					HeaderLoop: while (true) {
						if (position[0] >= fileBytes.length) break;

						//EBML Header
						var eid = readMatroskaVInt(fileBytes, position);
						if (!BytesEq(eid, HeaderEID)) {
							return False("未识别到此WebM文件Header");
						};
						multiHeader++;
						//跳过EBML Header内容
						readMatroskaBlock(fileBytes, position);

						//Segment
						var eid = readMatroskaVInt(fileBytes, position);
						if (!BytesEq(eid, SegmentEID)) {
							return False("未识别到此WebM文件Segment");
						};
						//跳过Segment长度值
						readMatroskaVInt(fileBytes, position);

						//循环读取Cluster
						while (true) {
							if (position[0] >= fileBytes.length) break;
							var eid0 = readMatroskaVInt(fileBytes, position);

							//Cluster
							if (BytesEq(eid0, ClusterEID)) {
								//跳过Cluster长度值
								readMatroskaVInt(fileBytes, position);

								var ablockIdx = 0;
								var bytes0 = fileBytes;
								var pos0 = position;
								var bytesTime0 = [];

								//循环读取SimpleBlock
								while (true) {
									if (pos0[0] >= bytes0.length) break;
									var eid1 = readMatroskaVInt(bytes0, pos0);
									if (BytesEq(eid1, HeaderEID)) {//下一个Header+Segment
										position[0] -= HeaderEID.length;//退回一下
										continue HeaderLoop;
									};
									if (BytesEq(eid1, ClusterEID)) {//下一个Cluster
										position[0] -= ClusterEID.length;//退回一下
										break;
									};

									var pos0_ = pos0[0];
									var bytes1Len = [];
									var bytes1 = readMatroskaBlock(bytes0, pos0, bytes1Len);
									var pos1 = [0];
									if (BytesEq(eid1, [0xE7])) {//Cluster 的当前时间
										bytesTime0 = [0xE7];
										for (var i = pos0_; i < pos0[0]; i++) {
											bytesTime0.push(bytes0[i]);
										}
										duration[multiHeader] = BytesInt(bytes1);
										duration2[multiHeader] = 0;
										continue;
									};

									//SimpleBlock
									if (BytesEq(eid1, [0xA3])) {
										var trackNo = bytes1[0] & 0xf;
										var track = tracks[trackNo];
										if (!track) throw new Error("轨道#" + trackNo + "的信息不存在");
										if (track.type == "audio" && track.audioTrackIdx === 0) {
											duration2[multiHeader] = BytesInt([bytes1[1], bytes1[2]]);
											var uint8 = new Uint8Array(bytes1.length - 4);
											for (var i = 4; i < bytes1.length; i++) {
												rawData.push(bytes1[i]);
												uint8[i - 4] = bytes1[i];
											}

											if (isPcm || /(\b|_)PCM\b/i.test(track.codec) && track.channels > 0 && track.bitDepth == 32) {
												//pcm数据转换成16位播放
												isPcm = true;
												var floatArr = new Float32Array(uint8.buffer);
												for (var i = 0; i < floatArr.length;) {
													var s = Math.max(-1, Math.min(1, floatArr[i]));
													s = s < 0 ? s * 0x8000 : s * 0x7FFF;
													playData.push(s & 0xff);
													playData.push((s >> 8) & 0xff);

													i += track.channels;
												}
											} else {
												//非pcm就用webm重新封装一下播放
												if (playData.length == 0) {
													Hex2Bytes(
														'1A45DFA3 9F 4286 81 01\
			42F7 81 01 42F2 81 04 42F3 81 08 4282 84 7765626D 4287 81 04 4285 81 02\
		18538067 01FFFFFFFFFFFFFF\
			1549A966 99 2AD7B1 83 0F4240 4D80 86 4368726F6D65 5741 86 4368726F6D65 1654AE6B', playData);
													playData.push(parseInt("1" + ("0000000" + track.srcBytes.length.toString(2)).substr(-7), 2));
													for (var i = 0; i < track.srcBytes.length; i++) {
														var b = track.srcBytes[i];
														playData.push(b);
														if (b == 0xD7 && track.srcBytes[i + 1] == 0x81) {//修正轨道编号
															playData.push(0x81); i++
															playData.push(0x01); i++
														}
													}
												};
												if (ablockIdx == 0) {
													Hex2Bytes('1F43B675 01FFFFFFFFFFFFFF', playData);
													playData.push.apply(playData, bytesTime0);
												};
												playData.push(0xA3);
												playData.push.apply(playData, bytes1Len);
												playData.push(0x81);
												for (var i = 1; i < bytes1.length; i++) {
													playData.push(bytes1[i]);
												}
											};
											ablockIdx++;
										}
									};
									//End SimpleBlock
								}
								continue;
							}
							//End Cluster

							var bytes0 = readMatroskaBlock(fileBytes, position);
							var pos0 = [0];

							//Track
							if (BytesEq(eid0, [0x16, 0x54, 0xAE, 0x6B])) {
								//循环读取TrackEntry
								while (true) {
									if (pos0[0] >= bytes0.length) break;
									var eid1 = readMatroskaVInt(bytes0, pos0);
									var bytes1Len = [];
									var bytes1 = readMatroskaBlock(bytes0, pos0, bytes1Len);
									var pos1 = [0];
									//TrackEntry
									if (BytesEq(eid1, [0xAE])) {
										var track = {};
										while (true) {
											if (pos1[0] >= bytes1.length) break;
											var eid2 = readMatroskaVInt(bytes1, pos1);
											var bytes2 = readMatroskaBlock(bytes1, pos1);
											var pos2 = [0];
											if (BytesEq(eid2, [0xD7])) {//Track Number
												var val = BytesInt(bytes2);
												track.number = val;
												if (multiHeader == 1) {
													tracks[val] = track;
												};
											} else if (BytesEq(eid2, [0x83])) {//Track Type
												var val = BytesInt(bytes2);
												if (val == 1) track.type = "video";
												else if (val == 2) {
													track.type = "audio";
													if (multiHeader == 1) {
														track.audioTrackIdx = audioTrackIdx++;
														if (track.audioTrackIdx == 0) {
															audioTrack0 = track;
														}
													}

													track.srcBytes = [0xAE];
													[].push.apply(track.srcBytes, bytes1Len);
													[].push.apply(track.srcBytes, bytes1);
												} else track.type = "Type-" + val;
											} else if (BytesEq(eid2, [0x86])) {//Track Codec
												track.codec = BytesStr(bytes2);
											} else if (BytesEq(eid2, [0xE0]) || BytesEq(eid2, [0xE1])) {
												//循环读取 Video 或 Audio 属性
												while (true) {
													if (pos2[0] >= bytes2.length) break;
													var eid3 = readMatroskaVInt(bytes2, pos2);
													var bytes3 = readMatroskaBlock(bytes2, pos2);
													//采样率、位数、声道数
													if (BytesEq(eid3, [0xB5])) track.sampleRate = Math.round(BytesFloat(bytes3));
													else if (BytesEq(eid3, [0x62, 0x64])) track.bitDepth = BytesInt(bytes3);
													else if (BytesEq(eid3, [0x9F])) track.channels = BytesInt(bytes3);
													//宽高
													else if (BytesEq(eid3, [0xB0])) track.width = BytesInt(bytes3);
													else if (BytesEq(eid3, [0xBA])) track.height = BytesInt(bytes3);
												}
											}
										}
										if (multiHeader > 1) {//多个Header时，不支不同持轨道参数
											var tk = tracks[track.number];
											if (!tk || tk.type != track.type || tk.codec != track.codec
												|| tk.sampleRate != track.sampleRate
												|| tk.bitDepth != track.bitDepth
												|| tk.channels != track.channels) {
												console.log(tk, track);
												throw new Error("WebM中有多个header时，不支持不一致的轨道参数");
											}
										}
										continue;
									}
									//End TrackEntry
									//不认识的，忽略
								}
								continue;
							}
							//End Track

							//不认识的，忽略
						};
						//End Cluster
					}
					//End Header+Segment
				} catch (e) {
					console.error(e);
					fileDownloading = false;
					$("#convertDialog").css("display", "none");
					return False("解析WebM文件提取音频异常：" + e.message);
				}
				if (!rawData.length) {
					fileDownloading = false;
					$("#convertDialog").css("display", "none");
					return False("未提取到此WebM文件的音频数据");
				}

				var dur = 0;
				for (var i = 1; i <= multiHeader; i++) {
					dur += duration[i] || 0;
					dur += duration2[i] || 0;
				}
				True({
					rawData: new Uint8Array(rawData)
					, rawTrack: audioTrack0

					, playBlob: new Blob([new Uint8Array(playData).buffer], { type: isPcm ? "audio/pcm" : "audio/webm" })
					, playType: isPcm ? "pcm" : "webm"
					, playSampleRate: audioTrack0.sampleRate || 0
					, playBitRate: isPcm ? 16 : 0

					, webmTracks: tracks
					, multiHeader: multiHeader
					, duration: dur
				});
			};
			reader.readAsArrayBuffer(webmBlob);
		};
		//两个字节数组内容是否相同
		function BytesEq(bytes1, bytes2) {
			if (bytes2.length == 1) {
				if (bytes1.length == 1) {
					return bytes1[0] == bytes2[0];
				}
				return false;
			}
			if (bytes1.length != bytes2.length) {
				return false;
			}
			for (var i = 0; i < bytes1.length; i++) {
				if (bytes1[i] != bytes2[i]) {
					return false;
				}
			}
			return true;
		};
		//16进制串转成字节数组
		function Hex2Bytes(hex, val) {
			val = val || [];
			hex = hex.replace(/[\s\r\n]/g, "");
			for (var i = 0; i < hex.length;) {
				val.push(parseInt(hex[i++] + hex[i++], 16));
			}
			return val;
		};
		//字节数组转成ASCII字符串
		function BytesStr(bytes) {
			var str = "";
			for (var i = 0; i < bytes.length; i++) {
				str += String.fromCharCode(bytes[i]);
			}
			return str;
		};
		//字节数组BE转成int数字
		function BytesInt(bytes) {
			var s = "";//0-8字节，js位运算只支持4字节
			for (var i = 0; i < bytes.length; i++) {
				var n = bytes[i];
				s += (n < 16 ? "0" : "") + n.toString(16);
			};
			return parseInt(s, 16) || 0;
		};
		//字节数组BE转成4|8字节浮点数
		function BytesFloat(bytes) {
			if (bytes.length == 4) {
				return new Float32Array(new Uint8Array(bytes.reverse()).buffer)[0];
			} else if (bytes.length == 8) {
				return new Float64Array(new Uint8Array(bytes.reverse()).buffer)[0];
			}
			throw new Error("浮点数长度必须为4或8");
		};
		//读取一个可变长数值字节数组
		function readMatroskaVInt(arr, pos, trimArr) {
			var i = pos[0];
			var b0 = arr[i], b2 = ("0000000" + b0.toString(2)).substr(-8);
			var m = /^(0*1)(\d*)$/.exec(b2);
			if (!m) throw new Error("readMatroskaVInt首字节无效: " + i);
			var len = m[1].length;
			var val = [];
			for (var i2 = 0; i2 < len && i < arr.length; i2++) {
				val[i2] = arr[i];
				if (trimArr) trimArr[i2] = arr[i];
				i++;
			}
			if (trimArr) {
				trimArr[0] = parseInt(m[2] || '0', 2);
			}
			pos[0] = i;
			return val;
		};
		//读取一个自带长度的内容字节数组
		function readMatroskaBlock(arr, pos, lenBytes) {
			var lenVal = [];
			var lenBytes2 = readMatroskaVInt(arr, pos, lenVal);
			if (lenBytes) lenBytes.push.apply(lenBytes, lenBytes2);

			var len = BytesInt(lenVal);
			var i = pos[0];
			var val = [];
			if (len < 0x7FFFFFFF) { //超大值代表没有长度
				for (var i2 = 0; i2 < len && i < arr.length; i2++) {
					val[i2] = arr[i];
					i++;
				}
			}
			pos[0] = i;
			return val;
		};
		//=====END=========================
	}
});

          })
        